import { axiosClient } from "apps/visits/config/axios-client";
import { HTTPMethods } from "apps/visits/packages/shared/static/http-methods";
import type { API } from "apps/visits/packages/shared/types/api";
import type { AxiosResponse } from "axios";
import update from "immutability-helper";
import { HttpClient } from "./HttpClient";

export default class BaseApi {
  protected http;

  constructor() {
    this.http = new HttpClient(axiosClient);
    this.http.client.defaults.headers.common["X-CSRF-Token"] = this.csrfToken();
  }

  csrfToken() {
    const csrfToken: any = document.getElementsByName("csrf-token")[0];
    return csrfToken?.content;
  }

  async request<T = any>(props: API.REQUEST_PROPS): Promise<T> {
    const { url, data, mapping, params, headers = {}, cache = true } = props;
    if (!cache) headers["Cache-control"] = "no-cache";

    let response: AxiosResponse<T>;
    switch (props.method) {
      default:
        response = await this.http.get<T>({
          url,
          params,
          headers,
        });
        break;
      case HTTPMethods.POST:
        response = await this.http.post<T>({ url, data, headers });
        break;
      case HTTPMethods.PUT:
        response = await this.http.put<T>({ url, data, headers });
        break;
      case HTTPMethods.PATCH:
        response = await this.http.patch<T>({ url, data, headers });
        break;
      case HTTPMethods.DELETE:
        response = await this.http.delete<T>({ url, headers });
        break;
    }

    if (mapping) {
      return update(response.data, mapping(response.data));
    }

    return response.data as T;
  }
}
